export const stepperTheme = {
  stepper: {
    container: {
      mobile: { margin: '0 0 24px 0', padding: '0' },
      tablet: { margin: '0 0 24px 0', padding: '0' },
      desktop: { margin: '0 0 24px 0', padding: '0' },
    },
    singleStep: {
      numericStep: {
        mobile: { width: '28px', height: '28px' },
        tablet: { width: '28px', height: '28px' },
        desktop: { width: '28px', height: '28px' },
      },
      inactiveStatus: {
        color: 'var(--stepper-idle)',
      },
      activeStatus: {
        color: 'var(--stepper-active-border)',
      },
      completedStatus: {
        color: 'var(--stepper-active)',
      },
      font: {
        family: 'var(--primary-font-family)',
        style: 'normal',
        weight: '500',
        size: '12px',
        lineHeight: '12px',
      },
      borderWidth: '.8px',
    },
  },
};
